import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box
} from '@mui/material';

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  onClose,
  title = 'Thank you for sharing your story!',
  content = (
    <>
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        We're so honored to be a part of your journey. Your photo and story bring our mission to
        life - and they just might inspire another family starting their own adventure with Stone
        Martin.
      </Typography>
      <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
        Keep an eye out... your moment could be featured in one of our upcoming homeowner
        spotlights!
      </Typography>
    </>
  )
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2
        }
      }}
    >
      <DialogTitle sx={{ typography: 'h2' }}>{title}</DialogTitle>

      <DialogContent>
        <Box sx={{ py: 1 }}>{content}</Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 1.5 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            minWidth: 120,
            px: 4
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
